import { render, staticRenderFns } from "./EditItemAction.vue?vue&type=template&id=d36f75e0&"
import script from "./EditItemAction.vue?vue&type=script&lang=js&"
export * from "./EditItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports